// extracted by mini-css-extract-plugin
module.exports = {"page":"Home_page__1xomT","stack":"Home_stack__3t8_2","img":"Home_img__3_oVm","title":"Home_title__yrS3W","text":"Home_text__r5wE9"};